import React, {useMemo} from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import {createUseStyles} from "react-jss";


const AccountAvatar = React.memo(({account, className, style, ...props}) => {
  const classes = useStyles();
  const styleEx = useMemo(() => {
    return {
      backgroundColor: getBgColor(account),
      ...(style || {}),
    };
  }, [account.id, style]);

  return (
    <div className={cn(classes.root, className)} style={styleEx} {...props}>
      <img
        src={account.image || '#'}
        alt={account.name}
        className={classes.img}
        onError={onImgError}
      />
    </div>
  )
});

AccountAvatar.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.any.isRequired,
    name: PropTypes.string,
    image: PropTypes.string,
  }).isRequired
};

const useStyles = createUseStyles({
  root: {
    borderRadius: '50%',
  },
  img: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: '#fff',
    objectFit: 'cover',
  },
});


export default AccountAvatar;


export function getBgColor(account) {
  const colors = [
    "#a6cee3", "#1f78b4", "#b2df8a", "#33a02c",
    "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00",
    "#cab2d6", "#6a3d9a", "#ffff99", "#b15928",
  ];

  return colors[account.id % colors.length];
}


const onImgError = (e) => {
  e.target.style.display = 'none';
};
